import React from 'react';

export default function RefundPolicy() {
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Cancellations and Refunds</h1>
      <p>Cancellation is allowed only before the item is shipped.</p>
      <p>Once shipped, orders cannot be canceled or refunded due to the live nature of livestock.</p>
      <p>Refunds are provided only in the case of DOA, with proper unboxing video proof.</p>
    </div>
  );
}
